module.exports = __webpack_public_path__ + "static/media/intro-hero-mobile.921494a0.png";